module.exports = __webpack_public_path__ + "img/Step05b4.4977e17d.webp";